module.exports = __webpack_public_path__ + "media/images/icon-close-bf29026b407fa67de11febac59e6e5a4.svg";